import { render, staticRenderFns } from "./RightBar.vue?vue&type=template&id=b0e9f0b8&scoped=true"
import script from "./RightBar.vue?vue&type=script&lang=js"
export * from "./RightBar.vue?vue&type=script&lang=js"
import style0 from "./RightBar.vue?vue&type=style&index=0&id=b0e9f0b8&prod&lang=css"
import style1 from "./RightBar.vue?vue&type=style&index=1&id=b0e9f0b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0e9f0b8",
  null
  
)

export default component.exports